export enum ExpressionTemplate {
Bonus,
Overtime,
NonWorkingDay,
PerQuantity,
Custom,
}
